import { render, staticRenderFns } from "./StandardPhrases.vue?vue&type=template&id=24dbf802&"
import script from "./StandardPhrases.vue?vue&type=script&lang=js&"
export * from "./StandardPhrases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports